// Carrier announcements (plate, driver, arrival or "no truck") per delivery.
// Without a backend they live in localStorage, so a carrier page opened in
// another tab of the same browser updates the arrivals overview live.

import { at, carriers } from '@/data/arrivalsData';
import { t } from '@/i18n';

// Demo stand-in for a signed per-carrier link; the real one comes from the backend (ADR #11).
const TOKENS = { D1: 'k7x2m', D2: 'q9w4t', D3: 'p3n8v', D4: 'h6r1c', D5: 'z5b7e' };
export const carrierToken = (id) => TOKENS[id];
export const carrierFromToken = (token) => carriers.find(c => TOKENS[c.id] === token) || null;

const KEY = 'omya_announcements';

export function readAnnouncements() {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; }
}

export function saveAnnouncement(orderId, data) {
  const all = { ...readAnnouncements(), [orderId]: { ...data, savedAt: new Date().toISOString() } };
  try { localStorage.setItem(KEY, JSON.stringify(all)); } catch { /* ignore */ }
  return all;
}

export function clearAnnouncements() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

// Applies stored announcements to the loadings (only changed ones get a new object).
export function applyAnnouncements(loadings, announcements) {
  return loadings.map(l => {
    const a = announcements[l.orderId];
    if (!a || l.announcedAt === a.savedAt) return l;
    const text = a.noTruck
      ? t('announce.msg.noTruck')
      : `${t('announce.msg.saved')}: ${a.plate}, ${a.driver}, ${a.eta}`;
    return {
      ...l,
      state: a.noTruck ? 'not-coming' : 'confirmed',
      plate: a.noTruck ? l.plate : a.plate,
      driver: a.noTruck ? l.driver : { ...l.driver, name: a.driver },
      eta: a.noTruck ? null : at(a.eta),
      announcedAt: a.savedAt,
      lastContact: a.savedAt,
      messages: [...l.messages, { time: a.savedAt, dir: 'in', channel: 'link', text }],
    };
  });
}
